import React, { useState, useEffect } from 'react'
import moment from 'moment';
import Dimensions from 'react-dimensions'
import { withTheme } from 'styled-components';
import {
    VictoryChart,
    VictoryBar,
    VictoryAxis,
    VictoryLabel,
} from "victory";
import { getTextWidth, toCurrency } from '../../../Utils/util';
import { Flex, FlexColumn, CardContainer } from '../../Reusable/Container';
import { Text, Tag } from '../../Reusable/Text';
import { Image } from '../../Reusable/Image';
import BackArrow from '../../../Images/chart-arrow-back-disabled.svg'
import ForwardArrow from '../../../Images/chart-arrow-forward-disabled.svg'

const BAR_WIDTH = 12;

const fillMissingMonths = (data, monthsToShow = 6) => {
    if (data.length === 0) return []; // Handle empty data case

    // Extract the start month and year from the first entry
    const [startMonth, startYear] = data[0].label.split('-').map(Number);

    const filledData = [];
    let currentMonth = startMonth;
    let currentYear = startYear;

    for (let i = 0; i < monthsToShow; i++) {
        const existingEntry = data.find(
            entry => entry.label === `${currentMonth}-${currentYear}`
        );

        if (existingEntry) {
            // Ensure `monthlyInterestAmount` is a number
            filledData.push({
                ...existingEntry,
                monthlyInterestAmount: Number(existingEntry.monthlyInterestAmount),
            });
        } else {
            filledData.push({
                label: `${currentMonth}-${currentYear}`,
                monthlyInterestAmount: 0,
            });
        }

        // Increment month and year as necessary
        currentMonth += 1;
        if (currentMonth > 12) {
            currentMonth = 1;
            currentYear += 1;
        }
    }

    return filledData;
};

const MonthlyInterestPaymentBarChart = ({ height, paddingOffset, data, theme, xLabel, yLabel, containerWidth }) => {
    const [step, setStep] = useState(0)
    const [chunkedData, setChunkedData] = useState([]);
    const [activeIndex, setActiveIndex] = useState(null);


    useEffect(() => {
        const chunkArray = (array, chunkSize) => {
            const chunks = [];

            const remainder = array.length % chunkSize;
            if (remainder !== 0 && remainder < chunkSize) {
                chunks.push(array.slice(0, remainder));
                array = array.slice(remainder);
            }

            for (let i = 0; i < array.length; i += chunkSize) {
                chunks.push(array.slice(i, i + chunkSize));
            }

            return chunks;
        }

        if (data) {
            data = fillMissingMonths(data)

            var chunkedData = chunkArray([...data], 6);

            console.log('cardTxnsSpendAnalysis', chunkedData)

            setChunkedData(chunkedData)
            setStep(chunkedData.length - 1)
        }
    }, [data]);

    return (
        <CardContainer style={{ height: '324px', width: containerWidth, padding: '24px' }}>
            <FlexColumn between left style={{ height: 320, width: containerWidth, paddingBottom: 24 }}>
                <Flex start style={{ width: containerWidth }}>
                    <Text heading style={{ zIndex: 1 }}>Monthly Interest</Text>
                </Flex>

                {
                    !data ?
                        <FlexColumn center style={{ height: 170, gap: 0, paddingTop: 28 }}>
                            <Text heading>No transactions</Text>
                            <Text width='400px' center>No spend to show</Text>
                        </FlexColumn>
                        :
                        <Flex bottom style={{ width: containerWidth - 48, height: 270, zIndex: 2, marginTop: -10 }}>
                            <Image width="30px" height="30px" src={BackArrow} margin="0 0 16px" />
                            {
                                chunkedData && chunkedData[step] &&
                                <VictoryChart
                                    height={220}
                                    width={containerWidth - 108}
                                    domain={{ x: [0.5, chunkedData[step].length + 0.5] }}  // Adjust the domain here
                                    domainPadding={{ x: [5, 0] }}  // Add padding to the left side of the chart
                                    padding={{ top: 38, right: 0, bottom: 20, left: 0 }}
                                    responsive={false}
                                >
                                    <VictoryBar
                                        cornerRadius={{ topLeft: 5, topRight: 5, bottomLeft: 5, bottomRight: 5 }}
                                        barWidth={BAR_WIDTH}
                                        style={{
                                            data: {
                                                fill: `${theme.colors.primary3}`,
                                                stroke: "transparent",
                                                strokeWidth: 1,
                                            },
                                        }}
                                        data={chunkedData[step] && [...chunkedData[step]]}
                                        // labels={({ datum }) => `$${toCurrency(datum.monthlyInterestAmount)}`}
                                        labelComponent={
                                            <VictoryLabel
                                                text={({ datum }) => `${datum.monthlyInterestAmount > 0 ? `$${toCurrency(datum.monthlyInterestAmount)}` : ''}`}
                                                dy={-10} // Adjusts the label's vertical position above the bar
                                                style={{
                                                    fill: 'black', // Set color for the label
                                                    fontSize: 14, // Adjust label font size
                                                    fontFamily: 'InterDisplay',
                                                    fontWeight: 'bold',
                                                }}
                                            />
                                        }
                                        x="label"
                                        y="monthlyInterestAmount"
                                    />

                                    <VictoryAxis
                                        tickFormat={(tick) => moment(tick, 'M-YYYY').format('MMM ‘YY')}
                                        style={{
                                            axis: { stroke: "transparent" },
                                            ticks: {},
                                            tickLabels: {
                                                fontSize: 14,
                                                fontFamily: 'InterDisplay'
                                            }
                                        }}
                                    />
                                </VictoryChart>
                            }
                            <Image width="30px" height="30px" src={ForwardArrow} margin="0 0 16px" />
                        </Flex>
                }
            </FlexColumn>
        </CardContainer>
    )
}

export default Dimensions({ elementResize: true })(withTheme(MonthlyInterestPaymentBarChart))
